import { Casier } from "./Casier";
import { ModeleDeBase } from "./ModeleDeBase";
import { ITypeClienteleCDS, TypeClientele } from "./TypeClientele";

export interface INiveauCDS {
  createdon?: string;
  si_message: string;
  si_niveausiid: string;
  si_niveau: string;
  si_Typedeclientele?: ITypeClienteleCDS;
  si_nomplan: string;
  si_CasierSI_si_NiveauSI_si_NiveauSI?: Casier[];
}

export class Niveau extends ModeleDeBase {
  nomNiveau: string;
  typeClientele?: TypeClientele;
  message: string;
  nombreCasiersDispos: number = 0;
  nomPlan: string;

  constructor(entity: INiveauCDS) {
    super(entity.si_niveausiid);
    if (entity.si_CasierSI_si_NiveauSI_si_NiveauSI !== undefined) {
      this.nombreCasiersDispos =
        entity.si_CasierSI_si_NiveauSI_si_NiveauSI.length;
    }

    this.nomNiveau = entity.si_niveau;
    if (entity.si_Typedeclientele) {
      this.typeClientele = new TypeClientele(entity.si_Typedeclientele);
    }
    this.nomPlan = entity.si_nomplan;
    this.message = entity.si_message;
  }

  serialiser(): INiveauCDS {
    return {
      si_niveausiid: this.id,
      si_niveau: this.nomNiveau,
      si_message: this.message,
      si_nomplan: this.nomPlan,
    };
  }
}
